import { render, staticRenderFns } from "./TeamRow.vue?vue&type=template&id=8a68843e&scoped=true"
import script from "./TeamRow.vue?vue&type=script&lang=js"
export * from "./TeamRow.vue?vue&type=script&lang=js"
import style0 from "./TeamRow.vue?vue&type=style&index=0&id=8a68843e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a68843e",
  null
  
)

export default component.exports